const layouts = {
  maxWidth: '2160px',
};
export default layouts;
